import { CookieKey, coreNativeModule } from "../types/RNCoreNativeModule";

const _VIEWJOB_DELETABLE_COOKIES = [CookieKey.clickTrackingLog] as const;
export type ViewJobDeletableCookies = (typeof _VIEWJOB_DELETABLE_COOKIES)[number];

// DO NOT USE THIS FUNCTION DIRECTLY. USE provider specific setter instead.
function deleteCookies<K extends CookieKey>(cookiesNames: readonly K[]): Promise<void> {
  const moduleRef = coreNativeModule();
  return moduleRef?.deleteCookies?.(cookiesNames) ?? Promise.resolve();
}

export function deleteCookiesForViewJob(
  cookiesNames: readonly ViewJobDeletableCookies[],
): Promise<void> {
  return deleteCookies(cookiesNames);
}
